/* CsakCsajok hírlevél-popup – 2026-10-20 (sections/cc-nl-popup.liquid) */
(function () {
  var root = document.getElementById('ccNl');
  var tpl = document.getElementById('ccNlTpl');
  if (!root || !tpl || root.dataset.ready) return;
  root.dataset.ready = '1';

  var html = document.documentElement;
  var DAY = 864e5;
  var cfg = {
    delay: (Number(root.dataset.delay) || 60) * 1000,
    exit: root.dataset.exit === '1',
    snooze: (Number(root.dataset.snooze) || 7) * DAY,
    code: root.dataset.code || 'CSAKCSAJOK10',
    design: root.dataset.design === '1'
  };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var now = function () { return Date.now(); };

  // ---------- állapot ----------
  // localStorage ccNl: { sub: ts, until: ts, n: bezárások száma }
  function rd() { try { return JSON.parse(localStorage.getItem('ccNl')) || {}; } catch (e) { return {}; } }
  function wr(o) { if (cfg.design) return; try { localStorage.setItem('ccNl', JSON.stringify(o)); } catch (e) {} }
  function sg(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  var q = location.search;
  var st = rd();
  if (/[?&]ccnl=reset\b/.test(q)) { st = {}; wr(st); sset('ccNlT', '0'); sset('ccNlTab', ''); }
  var force = /[?&]ccnl=1\b/.test(q);
  // hírlevélből érkezett: nem kínáljuk fel neki újra (30 napig)
  if (/[?&]utm_medium=email\b/i.test(q) && !st.sub) { st.until = now() + 30 * DAY; wr(st); }
  var returning = sg('ccNlPending') === '1' && /[?&]customer_posted=true\b/.test(q);

  if (st.sub && !force && !cfg.design) return;

  var dlg, form, built = false, tick = 0, lastBusy = 0, acc = Number(sg('ccNlT')) || 0, engaged = sg('ccNlE') === '1';

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(name, { detail: data || {} })); } catch (e) {}
  }

  // ---------- építés ----------
  function build() {
    if (built) return;
    built = true;
    root.appendChild(tpl.content.cloneNode(true));
    dlg = root.querySelector('dialog.ccnl');
    form = dlg.querySelector('form');
    form.noValidate = true;
    wire();
  }

  function tab(show) {
    if (!built) { if (!show) return; build(); }
    var t = root.querySelector('.ccnl-tab');
    if (t) t.hidden = !show;
  }

  // ---------- mikor ne zavarjunk ----------
  function visible(el) { return !!el && el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; }
  function busy() {
    if (html.classList.contains('cc-ag-lock') || document.getElementById('ccAg')) return true;
    if (now() - lastBusy < 12000) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a)) return true;
    if (visible(document.getElementById('shopify-pc__banner'))) return true;
    if (document.querySelector('dialog[open]')) return true;
    var m = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < m.length; i++) if (!root.contains(m[i]) && visible(m[i])) return true;
    // a téma fiókjai/menüi görgetés-zárral nyílnak
    if (getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(html).overflow === 'hidden') return true;
    return false;
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[name="add"], [type="submit"][form^="product-form"], .js-add-to-cart, [data-cc-add], [data-ccu-add], a[href*="/checkout"], [name="checkout"]')) lastBusy = now();
  }, true);
  ['cc:cart-updated', 'cart:update', 'cart:updated'].forEach(function (n) { document.addEventListener(n, function () { lastBusy = now(); }); });

  // ---------- nyitás / zárás ----------
  function open(src) {
    build();
    if (dlg.open) return;
    clearInterval(tick);
    tab(false);
    dlg.classList.remove('is-out');
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    html.classList.add('ccnl-lock');
    dlg.classList.add('is-in');
    // mobilon ne ugorjon fel a billentyűzet: a címre tesszük a fókuszt
    var h = dlg.querySelector('[data-ccnl-step]:not([hidden]) .ccnl-t');
    try { (fine ? dlg.querySelector('#ccNlEmail') : h).focus({ preventScroll: true }); } catch (e) {}
    track('cc_nl_open', { source: src });
  }

  function close(reason) {
    if (!dlg || !dlg.open) return;
    var won = dlg.classList.contains('is-won');
    dlg.classList.remove('is-in');
    dlg.classList.add('is-out');
    var card = dlg.querySelector('.ccnl-card');
    var done = function () {
      dlg.close();
      dlg.classList.remove('is-out');
      card.style.transform = '';
      html.classList.remove('ccnl-lock');
    };
    if (reduce) done(); else setTimeout(done, 300);
    if (won || cfg.design) return;
    st.n = (st.n || 0) + 1;
    st.until = now() + (st.n >= 2 ? 30 * DAY : cfg.snooze);
    wr(st);
    if (sg('ccNlTabOff') !== '1') { sset('ccNlTab', '1'); setTimeout(function () { tab(true); }, 400); }
    track('cc_nl_dismiss', { reason: reason });
  }

  // ---------- esemény-bekötés ----------
  function wire() {
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close('esc'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { close('backdrop'); return; }
      if (e.target.closest('[data-ccnl-close]')) close('button');
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ccnl-reopen]')) open('tab');
      else if (e.target.closest('[data-ccnl-tabx]')) { sset('ccNlTab', ''); sset('ccNlTabOff', '1'); tab(false); }
    });

    form.addEventListener('submit', submit);
    var em = form.querySelector('#ccNlEmail');
    em.addEventListener('input', function () { if (form.classList.contains('is-bad')) err(''); });

    var cp = dlg.querySelector('[data-ccnl-copy]');
    cp.addEventListener('click', function () {
      var ok = function () {
        cp.classList.add('is-ok');
        cp.querySelector('[data-ccnl-cpl]').textContent = 'Kimásolva ✓';
        if (navigator.vibrate) try { navigator.vibrate(8); } catch (e) {}
        setTimeout(function () { cp.classList.remove('is-ok'); cp.querySelector('[data-ccnl-cpl]').textContent = 'Másolás'; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cfg.code).then(ok, fallbackCopy);
      else fallbackCopy();
      function fallbackCopy() {
        var r = document.createRange(); r.selectNodeContents(dlg.querySelector('.ccnl-code__v'));
        var s = getSelection(); s.removeAllRanges(); s.addRange(r);
        try { document.execCommand('copy'); ok(); } catch (e) {}
      }
    });

    // kupon-billegés egérrel
    var vis = dlg.querySelector('.ccnl-vis'), tilt = dlg.querySelector('.ccnl-tilt'), raf = 0;
    if (fine && !reduce) {
      vis.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var b = vis.getBoundingClientRect();
          var x = (e.clientX - b.left) / b.width - 0.5, y = (e.clientY - b.top) / b.height - 0.5;
          tilt.style.setProperty('--ry', (x * 16).toFixed(2) + 'deg');
          tilt.style.setProperty('--rx', (-y * 12).toFixed(2) + 'deg');
        });
      });
      vis.addEventListener('pointerleave', function () { tilt.style.setProperty('--rx', '0deg'); tilt.style.setProperty('--ry', '0deg'); });
    }

    // mobil: lehúzással zárható alsó lap
    var card = dlg.querySelector('.ccnl-card');
    var startY = 0, dy = 0, t0 = 0, drag = false;
    function down(e) {
      if (!matchMedia('(max-width: 759px)').matches || e.target.closest('button, a, input, label')) return;
      if (card.scrollTop > 0) return;
      drag = true; startY = e.clientY; dy = 0; t0 = now();
      card.style.transition = 'none';
    }
    function move(e) {
      if (!drag) return;
      dy = Math.max(0, e.clientY - startY);
      card.style.transform = 'translateY(' + dy + 'px)';
    }
    function up() {
      if (!drag) return;
      drag = false;
      var v = dy / Math.max(1, now() - t0);
      card.style.transition = 'transform .3s cubic-bezier(.22,1,.36,1)';
      if (dy > 110 || v > 0.6) { card.style.transform = 'translateY(100%)'; setTimeout(function () { card.style.transition = ''; close('swipe'); }, 260); }
      else { card.style.transform = ''; setTimeout(function () { card.style.transition = ''; }, 300); }
    }
    [dlg.querySelector('.ccnl-grab'), vis].forEach(function (el) { el.addEventListener('pointerdown', down); });
    addEventListener('pointermove', move, { passive: true });
    addEventListener('pointerup', up);
    addEventListener('pointercancel', up);
  }

  // ---------- beküldés ----------
  function err(msg) {
    form.classList.toggle('is-bad', !!msg);
    form.querySelector('#ccNlErr').textContent = msg || '';
    if (msg) { form.classList.remove('is-shake'); void form.offsetWidth; form.classList.add('is-shake'); }
  }
  function loading(on) { form.querySelector('[data-ccnl-submit]').classList.toggle('is-load', on); }

  function submit(e) {
    e.preventDefault();
    var em = form.querySelector('#ccNlEmail');
    var v = em.value.trim();
    em.value = v;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
      err(v ? 'Hoppá, ez nem tűnik e-mail címnek. Megnézed még egyszer?' : 'Írd be az e-mail címed, és már küldjük is a kódot.');
      em.focus();
      return;
    }
    err('');
    var tags = ['newsletter', 'popup'];
    form.querySelectorAll('[data-ccnl-int]:checked').forEach(function (c) { tags.push(c.value); });
    form.querySelector('[name="contact[tags]"]').value = tags.join(',');
    if (cfg.design) { success(); return; }
    loading(true);
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (/\/challenge/.test(r.url)) {
          // a Shopify robot-ellenőrzést kér: rendes beküldés, visszaúton nyitjuk a sikert
          sset('ccNlPending', '1');
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        if (/customer_posted=true/.test(r.url)) { success(); return; }
        return r.text().then(function (t) {
          var msg = '';
          try {
            var d = new DOMParser().parseFromString(t, 'text/html');
            var tp = d.getElementById('ccNlTpl');
            var m = tp && tp.content.querySelector('[data-ccnl-err]');
            msg = m ? m.textContent.trim() : '';
          } catch (x) {}
          if (/taken|már|regisztr|exist/i.test(msg)) { success(true); return; }
          err('Nem sikerült a feliratkozás. Ellenőrizd az e-mail-címed, és próbáld újra.');
        });
      })
      .catch(function () { err('Úgy tűnik, megszakadt a net. Próbáld újra!'); })
      .then(function () { loading(false); });
  }

  function success(already) {
    st.sub = now(); delete st.until; wr(st);
    sset('ccNlPending', ''); sset('ccNlTab', '');
    if (!cfg.design) fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' }).catch(function () {});
    var card = dlg.querySelector('.ccnl-card');
    if (matchMedia('(min-width: 760px)').matches) card.style.minHeight = card.offsetHeight + 'px';
    dlg.querySelector('[data-ccnl-step=form]').hidden = true;
    var ok = dlg.querySelector('[data-ccnl-step=ok]');
    ok.hidden = false;
    if (already) ok.querySelector('[data-ccnl-okt]').textContent = 'Már a listán vagy – itt a 10%-od.';
    dlg.classList.add('is-won');
    try { ok.querySelector('[data-ccnl-okt]').focus({ preventScroll: true }); } catch (e) {}
    if (navigator.vibrate) try { navigator.vibrate([10, 40, 14]); } catch (e) {}
    hearts();
    track('cc_nl_subscribe', { already: !!already });
  }

  function hearts() {
    if (reduce || !Element.prototype.animate) return;
    var stage = dlg.querySelector('.ccnl-stage');
    var svg = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9.3C.3 8.3 2.3 4 6.4 4c2.4 0 4 1.4 5.6 3.3C13.6 5.4 15.2 4 17.6 4 21.7 4 23.7 8.3 22 11.7 19.5 16.4 12 21 12 21z"/></svg>';
    for (var i = 0; i < 14; i++) {
      var h = document.createElement('span');
      h.className = 'ccnl-heart';
      h.innerHTML = svg;
      if (i % 3 === 0) h.style.color = '#fff';
      stage.appendChild(h);
      var a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4, r = 80 + Math.random() * 90;
      var x = Math.cos(a) * r, y = Math.sin(a) * r * 0.75 - 20, s = 0.6 + Math.random() * 0.8, rot = (Math.random() - 0.5) * 70;
      h.animate([
        { transform: 'translate(0,0) scale(.2)', opacity: 0 },
        { transform: 'translate(' + x * 0.55 + 'px,' + y * 0.55 + 'px) scale(' + s + ') rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.35 },
        { transform: 'translate(' + x + 'px,' + (y + 40) + 'px) scale(' + s * 0.8 + ') rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.22,1,.36,1)', delay: 120 + Math.random() * 120, fill: 'forwards' }).onfinish = (function (el) { return function () { el.remove(); }; })(h);
    }
  }

  // ---------- indítás ----------
  if (cfg.design) {
    document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === root.dataset.sid) open('editor'); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === root.dataset.sid) close('editor'); });
    return;
  }

  if (returning) {
    var w = setInterval(function () { if (!html.classList.contains('cc-ag-lock')) { clearInterval(w); open('return'); success(); } }, 300);
    return;
  }
  if (force) { var f = setInterval(function () { if (!busy() || html.classList.contains('cc-ag-ok')) { clearInterval(f); open('force'); } }, 300); return; }

  var snoozed = st.until && st.until > now();
  if (snoozed) { if (sg('ccNlTab') === '1') tab(true); return; }

  function engage() { if (!engaged) { engaged = true; sset('ccNlE', '1'); } }
  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (n) { addEventListener(n, engage, { passive: true, once: true }); });

  tick = setInterval(function () {
    if (document.visibilityState !== 'visible' || html.classList.contains('cc-ag-lock') || !engaged) return;
    acc += 1000;
    sset('ccNlT', String(acc));
    if (acc >= cfg.delay && !busy()) open('timer');
  }, 1000);

  if (cfg.exit && fine) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 8 || acc < 15000 || (dlg && dlg.open) || busy()) return;
      if (rd().until > now()) return;
      open('exit');
    });
  }
})();
